module.exports = __webpack_public_path__ + "static-portal/img/LIMS.10c7a58.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/LIMS.png
// module id = ZcF1
// module chunks = 4